import * as React from "react";
function Aspect2By3Icon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 10,
    x: 17,
    y: 4,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    rx: 1,
    transform: "rotate(90 17 4)"
  }));
}
const ForwardRef = React.forwardRef(Aspect2By3Icon);
export default ForwardRef;